module.exports = __webpack_public_path__ + "img/mind_icon_number_1.c6ac287f.png";